import { tokens } from "@fluentui/react-components";
import { ResponsiveContainer, Tooltip, Treemap } from "recharts";
import { useTheme } from "styled-components";

import { CustomizedContent } from "./CustomizedContent";
import { CustomTooltip } from "./CustomTooltip";

const DEFAULT_COLORS = ["#8889DD", "#9597E4", "#8DC77B", "#A5D297", "#E2CF45", "#F8C12D"];

type Props = {
  width?: number;
  height?: number;
  data?: any[];
  stroke?: string;
  fill?: string;
  colors?: string[];
};
export function TreeMapComponent({
  width,
  height,
  data = [],
  stroke,
  fill,
  colors = DEFAULT_COLORS,
}: Props) {
  const theme = useTheme();
  return (
    <ResponsiveContainer width="100%" height="100%">
      <>
        <Treemap
          width={width}
          height={height}
          data={data}
          dataKey="size"
          stroke={stroke || theme.palette.white}
          fill={fill || tokens.colorPaletteDarkOrangeBackground2}
          content={<CustomizedContent colors={colors} />}
        >
          <Tooltip content={<CustomTooltip />} />
        </Treemap>
      </>
    </ResponsiveContainer>
  );
}
